import { Card, Skeleton, Stack } from '@mantine/core';

export function ProdukSkeleton() {
  return (
    <>
    <Card
    radius="md"
    withBorder
    p={{ base: 'xs', sm: 'sm', md: 'md' }}
    miw={{ base: 120, sm: 160, md: 200, lg: 220 }}
    style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    }}
    >
    <Skeleton
        w="100%"
        h={{ base: '100', sm: '110', lg: '150' }}
        mb="sm"
    />
    <Stack gap={10}>
        <Skeleton
        h={15}
        w="50%"
        />
        <Skeleton
        h={15}
        w="80%"
        />
        <Skeleton
        h={30}
        w="100%"
        />
    </Stack>
    </Card>
    </>
  );
}
